<template>
  <div>
    <div class="title">
      Follow us
    </div>
    <div class="mx-1">
      <a
        href="https://www.facebook.com/motionarray"
        target="_blank"
        rel="noopener noreferrer"
        class="mx-2 w-5 h-5"
        @click="tracksocialInteractionEvent('facebook', 'https://www.facebook.com/motionarray')"
      >
        <i class="fab fa-facebook-f fa-lg icon" />
      </a>
      <a
        href="https://www.instagram.com/motionarray"
        target="_blank"
        rel="noopener noreferrer"
        class="mx-2 w-5 h-5"
        @click="tracksocialInteractionEvent('instagram', 'https://www.instagram.com/motionarray')"
      >
        <i class="fab fa-instagram fa-lg icon" />
      </a>
      <a
        href="https://twitter.com/MotionArray"
        target="_blank"
        rel="noopener noreferrer"
        class="mx-2 w-5 h-5"
        @click="tracksocialInteractionEvent('twitter', 'https://twitter.com/MotionArray')"
      >
        <i class="fab fa-twitter fa-lg icon" />
      </a>
      <a
        href="https://www.youtube.com/c/MotionArrayTutorials"
        target="_blank"
        rel="noopener noreferrer"
        class="mx-2 w-5 h-5"
        @click="tracksocialInteractionEvent('youtube', 'https://www.youtube.com/c/MotionArrayTutorials')"
      >
        <i class="fab fa-youtube fa-lg icon" />
      </a>
    </div>
  </div>
</template>

<script>
import analyticsEvents from '@/utils/analyticsEvents';
import { eventTracker } from '@/utils/eventTracker';
import gtmEvents from '@/utils/gtmEvents';
import { dataLayerTrack } from '@/utils/datalayer';

export default {
  name: 'MainFooter',
  methods: {
    tracksocialInteractionEvent(name, clickUrl) {
      const eventData = {
        sectionId: 'mobile-menu',
        name,
        clickUrl
      };
      eventTracker(analyticsEvents.socialInteraction, eventData);
      dataLayerTrack({ eventName: gtmEvents.socialInteraction, data: eventData });
    }
  }
};
</script>

<style scoped>
.title {
  margin: 40px 16px 25px;
  text-transform: uppercase;
  font-size: 14px;
  line-height: 16px;
  @apply text-p40;
}

.icon {
  @apply text-primary-offwhite;
}
</style>
